import {
  ActorModel,
  FhirClientPort,
  SupportedActorResource,
  SupportedActorType,
} from "./fhir.types";
import { isSupportedActorResource, mapActorResource } from "./fhir.utils";

const resourceTypeByActorType: Record<SupportedActorType, string> = {
  patient: "Patient",
  practitioner: "Practitioner",
  location: "Location",
  device: "Device",
};

export class ActorService {
  constructor(private readonly client: FhirClientPort) {}

  async getById(
    actorType: SupportedActorType,
    id: string,
  ): Promise<ActorModel | undefined> {
    const resource = await this.client.read(resourceTypeByActorType[actorType], id);
    if (!isSupportedActorResource(resource)) {
      return undefined;
    }
    return mapActorResource(resource as SupportedActorResource);
  }
}
